var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3125 9.61582L7.90165 16.0266C6.43718 17.4911 4.06282 17.4911 2.59835 16.0266C1.13388 14.5622 1.13388 12.1878 2.59835 10.7233L11.7144 1.60723C12.6907 0.630922 14.2736 0.630923 15.2499 1.60723C16.2262 2.58354 16.2262 4.16646 15.2499 5.14277L6.12632 14.2664M6.13388 14.2589C6.13137 14.2614 6.12885 14.2639 6.12632 14.2664M10.8749 5.98221L4.36612 12.4911C3.87796 12.9793 3.87796 13.7707 4.36612 14.2589C4.85176 14.7445 5.63759 14.747 6.12632 14.2664",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.93578437f130db467d7b25c93b40c07c.svg";
export { ForwardRef as ReactComponent };